(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/utils/price-range.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/utils/price-range.js');

'use strict';

const Range = {
  RANGE_ALL: 0,
  RANGE_10_50: 1,
  RANGE_51_100: 2,
  RANGE_101_200: 3,
  RANGE_201_300: 4,
  RANGE_301_500: 5,
  RANGE_501_999: 6,
  RANGE_1000_UP: 7
};
const PriceRange = {
  [Range.RANGE_ALL]: {
    selectedMin: 10,
    selectedMax: 10000
  },
  [Range.RANGE_10_50]: {
    selectedMin: 10,
    selectedMax: 50
  },
  [Range.RANGE_51_100]: {
    selectedMin: 51,
    selectedMax: 100
  },
  [Range.RANGE_101_200]: {
    selectedMin: 101,
    selectedMax: 200
  },
  [Range.RANGE_201_300]: {
    selectedMin: 201,
    selectedMax: 300
  },
  [Range.RANGE_301_500]: {
    selectedMin: 301,
    selectedMax: 500
  },
  [Range.RANGE_501_999]: {
    selectedMin: 501,
    selectedMax: 999
  },
  [Range.RANGE_1000_UP]: {
    selectedMin: 1000,
    selectedMax: 10000
  }
};
const radioOptions = [{
  ariaLabel: 'Visa alla',
  label: 'Alla',
  value: Range.RANGE_ALL
}, {
  ariaLabel: 'Visa 10 till 50 kronor',
  label: '10-50 kr',
  value: Range.RANGE_10_50
}, {
  ariaLabel: 'Visa 51 till 100 kronor',
  label: '51-100 kr',
  value: Range.RANGE_51_100
}, {
  ariaLabel: 'Visa 101 till 200 kronor',
  label: '101-200 kr',
  value: Range.RANGE_101_200
}, {
  ariaLabel: 'Visa 201 till 300 kronor',
  label: '201-300 kr',
  value: Range.RANGE_201_300
}, {
  ariaLabel: 'Visa 301 till 500 kronor',
  label: '301-500 kr',
  value: Range.RANGE_301_500
}, {
  ariaLabel: 'Visa 501 till 999 kronor',
  label: '501-999 kr',
  value: Range.RANGE_501_999
}, {
  ariaLabel: 'Visa 1000 kronor och uppåt',
  label: '+ 1000 kr',
  value: Range.RANGE_1000_UP
}];
setGlobal('svs.components.tipsen.utils.range', {
  PriceRange,
  radioOptions,
  Range
});

 })(window);